const userConst = {
  adminLogin: 'admin/auth/login',
  profile: 'admin/users/profile',
  updateMyProfile: 'admin/users/my-profile',
}

export default userConst
